<template>
  <div>
    <h1>Привіт, {{firstname}}</h1>

    <h2>Трекер відвідуваності</h2>

    <p v-if="schoolClasses === undefined"><i>Завантаження...</i></p>

    <p v-if="schoolClasses !== undefined">Виберіть свій шкільний клас:</p>

    <button v-for="(schoolClass, index) in schoolClasses" @click="$router.push('/attendance/' + schoolClass)" class="btn btn-outline-dark"><icon name="book"></icon>{{ schoolClass }}</button>

    <h2 v-if="cognitoGroups.includes('AdministratorGroup')">Administrator accesses only</h2>

    <button v-if="cognitoGroups.includes('AdministratorGroup')" @click="$router.push('/statistics/')" class="btn btn-outline-dark"><icon name="book"></icon>Statistics</button>
  </div>
</template>

<script>

import 'vue-awesome/icons/book'
import AWS from 'aws-sdk'

export default {
  name: 'home',
  data: function () {
    return {
      schoolClasses: undefined
    }
  },
  computed: {
    firstname () {
      if (this.$store.getters.userInfo !== null) {
        return this.$store.getters.userInfo.name.split(' ')[0]
      } else {
        return null
      }
    },
    cognitoGroups () {
      if (this.$store.getters.jwtPayload !== null) {
        return this.$store.getters.jwtPayload['cognito:groups']
      } else {
        return []
      }
    }
  },
  async created () {
    try {
      if (this.$store.getters.isOAuth2TokenExpired) {
        await this.$store.dispatch('refreshCodeGrant')
      }

      const lambda = new AWS.Lambda({
        credentials: await this.$store.getters.awsCredentials,
        region: process.env.AWS_REGION
      })

      const lambdaResult = await lambda.invoke({
        FunctionName: process.env.LAMBDA_FUNCTION_ARN,
        Payload: JSON.stringify({
          action: 'list_worksheets',
          cognito_userinfo: await this.$store.getters.userInfo
        })
      }).promise()

      const listWorksheets = JSON.parse(lambdaResult.Payload)

      if ('errorMessage' in listWorksheets) {
        throw new Error(JSON.stringify(listWorksheets, undefined, 2))
      }

      this.schoolClasses = listWorksheets.body
    } catch (error) {
      this.$router.push({ name: 'error', params: { message: error.message } })
      return
    }
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?121af164